(() => {
    class t extends HTMLElement {
        video;
        bigButton;
        smallButton;
        button;
        time;
        bar;
        timer;
        wrapper;
        constructor() {
            super(),
                (this.video = this.querySelector("video")),
                (this.wrapper = this.closest(".video-players")),
                (this.bigButton = this.querySelector(".video_big-button")),
                (this.smallButton = this.querySelector(".video_small-button")),
                (this.button = this.wrapper.querySelector('.video_button[data-target="' + this.id + '"]')),
                (this.time = this.querySelector(".video_time")),
                (this.bar = this.querySelector(".video_bar")),
                (this.timer = new window.theme.utils.Timer(this.handleTime.bind(this))),
                this.button.addEventListener("click", this.switchVideo.bind(this)),
                this.bigButton.addEventListener("click", this.handleVideo.bind(this)),
                this.smallButton.addEventListener("click", this.handleVideo.bind(this)),
                this.addEventListener("mouseenter", this.showBar.bind(this)),
                this.addEventListener("mouseleave", this.hideBar.bind(this)),
                this.video.addEventListener("click", this.handleVideo.bind(this)),
                this.video.addEventListener("play", this.playVideo.bind(this)),
                this.video.addEventListener("pause", this.pauseVideo.bind(this)),
                this.video.addEventListener("ended", this.endVideo.bind(this)),
                this.video.addEventListener("loadeddata", this.initVideo.bind(this));
        }
        initVideo() {
            this.timer.start(), (this.dataset.status = "playing");
        }
        playVideo() {
            "init" == this.dataset.status ? (this.dataset.status = "loading") : (this.timer.start(), (this.dataset.status = "playing"));
        }
        pauseVideo() {
            this.timer.stop(), (this.dataset.status = "paused");
        }
        endVideo() {
            this.timer.stop(), (this.dataset.status = "ended");
        }
        handleVideo() {
            let t;
            this.video.paused ? (t = this.video.play()) : (this.video.pause(), this.bar.classList.add("bar-visible")),
                void 0 !== t &&
                    t.catch(function (t) {
                        // console.log("error: ", t);
                    });
        }
        handleTime() {
            let t = Math.round(this.video.currentTime);
            t < 10 && (t = "0" + t), (this.time.innerHTML = "00:" + t);
        }
        showBar() {
            "playing" === this.dataset.status && this.bar.classList.add("bar-visible");
        }
        hideBar() {
            "playing" === this.dataset.status && this.bar.classList.remove("bar-visible");
        }
        switchVideo() {
            var t = this.wrapper.querySelectorAll("video-player"),
                e = this;
            t.forEach(function (t) {
                t.id === e.id ? (e.removeAttribute("hidden")) : (t.setAttribute("hidden", ""));
            }),
                this.wrapper.querySelector(".video_button[active]").removeAttribute("active"),
                this.button.setAttribute("active", "");
        }
    }
    customElements.define("video-player", t),
        (function () {
            function t(t, e) {
                const i = e.querySelectorAll("video-player"),
                    s = e.querySelector("video-player:not([hidden])"),
                    d = i.length - 1,
                    o = s.querySelector(".video_small-button");
                let a;
                ("playing" !== s.dataset.status && "loading" !== s.dataset.status) || o.click(),
                    s.setAttribute("hidden", ""),
                    "prev" === t && "1" !== s.dataset.position
                        ? (a = s.previousElementSibling)
                        : "prev" === t && "1" === s.dataset.position
                        ? (a = i[d])
                        : "next" === t && "3" !== s.dataset.position
                        ? (a = s.nextElementSibling)
                        : "next" === t && "3" === s.dataset.position && (a = i[0]),
                    a.removeAttribute("hidden"),
                    (e.querySelector(".videos_navigation .blue").innerHTML = "0" + a.dataset.position),
                    e.querySelector('.video_button[data-target="' + s.id + '"]').removeAttribute("active"),
                    e.querySelector('.video_button[data-target="' + a.id + '"]').setAttribute("active", "");
            }
            document.querySelectorAll(".video-players").forEach((e) => {
                e.querySelector(".videos_navigation") &&
                    (e.querySelector(".videos_navigation .icon-arrow-left").addEventListener("click", () => {
                        t("prev", e);
                    }),
                    e.querySelector(".videos_navigation .icon-arrow-right").addEventListener("click", () => {
                        t("next", e);
                    }));
            }),
                document.querySelectorAll(".video-players__toggles button").forEach((t) => {
                    t.addEventListener("click", () => {
                        const e = document.querySelector(".video-players:not([hidden])");
                        e.setAttribute("hidden", "");
                        const i = e.querySelector('[data-status="playing"] video');
                        i && i.click(), document.querySelector(".video-players__toggles .underline").classList.remove("underline"), t.classList.add("underline");
                        const s = document.querySelector(`.video-players[data-position="${t.dataset.position}"]`);
                        s.removeAttribute("hidden"), s.querySelector("video-player:not([hidden]) video").click();
                    });
                });
        })();
})();
